import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';
import initHelpHero from 'helphero';
import intl from 'react-intl-universal';

import enUS from 'locales/en-US';
import zhCN from 'locales/zh-CN';
import thTH from 'locales/th-TH';
import idID from 'locales/id-ID';
import { setLocale as setDateLocale } from './utils/dateUtil';
import { LANGUAGE_KEY_MAPPING } from 'common/constants';
import SelectTemplateScreen from './container/SelectTemplateScreen';
import EditorScreen from './container/EditorScreen';
import HomeScreen from './container/HomeScreen';
import AuthenticationScreen from './container/AuthenticationScreen';
import PreviewPage from './container/PreviewPage';

const locales = {
	'en-US': enUS,
	'en-MY': enUS,
	'id-ID': idID,
	'zh-CN': zhCN,
	'th-TH': thTH,
};

// const LANGUAGE_KEY_MAPPING = {
// 	en: 'en-US',
// 	zh: 'zh-CN',
// 	th: 'th-TH'
// };

const getBrowserLanguage = () => {
	const currentLanguage = navigator.language;
	const keys = currentLanguage ? currentLanguage.split('-') : null;
	let languageKey = 'en';
	if (keys?.length > 0) {
		languageKey = keys[0];
	}
	return LANGUAGE_KEY_MAPPING[languageKey] || null;
};

String.prototype.capitalize = function () {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

function App() {
	// const reportMode = useStoreState(state => state.token.reportMode);
	// window.reportMode = reportMode;
	const userId = useStoreState((state) => state.template?.adviserData?.id);
	const locale = useStoreState((state) => state.template?.adviserData?.locale);

	const [, setLocaleInitialized] = useState(false);

	window.NEXT_PUBLIC_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

	useEffect(() => {
		const hlp = initHelpHero(process.env.REACT_APP_HELP_HERO_KEY);
		if (userId) {
			hlp.identify(userId);
		} else {
			hlp.anonymous();
		}
	}, [userId]);

	useEffect(() => {
		const appLocale = locale || getBrowserLanguage();
		// init method will load CLDR locale data according to currentLocale
		// react-intl-universal is singleton, so you should init it only once in your app
		/*
		 * Get browser's language
		 */
		console.log('Init2', appLocale);
		if (appLocale) {
			setDateLocale(appLocale);
			const intlLocale = locales[appLocale] ? appLocale : 'en-US';
			intl.init({
				currentLocale: intlLocale,
				locales,
				warningHandler: (message) => {
					console.warn(message);
				},
			})
				.then(() => {
					setLocaleInitialized(true);
				})
				.catch((error) => {
					console.error('Error loading locale', { error, appLocale });
				});
		}
	}, [locale]);

	return (
		<Router basename="/html-builder">
			<Switch>
				<Route path="/select_template">
					<SelectTemplateScreen />
				</Route>
				<Route path="/editor">
					<EditorScreen />
				</Route>
				<Route path="/preview/:template">
					<PreviewPage />
				</Route>
				<Route path="/authentication/login/:status/:data">
					<AuthenticationScreen />
				</Route>
				<Route exact path="/">
					<HomeScreen />
				</Route>
			</Switch>
		</Router>
	);
}

export default App;
